import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40a1b69c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icp" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn",
    target: "_blank"
  }, "浙ICP备19021700号")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GalaxyGenerator = _resolveComponent("GalaxyGenerator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GalaxyGenerator),
    _hoisted_2
  ]))
}